export default "__VITE_ASSET__y5Bi9Fgv__"